import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { api, ArchiveDocumentsResponseDto } from '@sib/api';

export interface UseCreateZipJobOptions
  extends UseMutationOptions<
    ArchiveDocumentsResponseDto,
    Error,
    { organizationId: string; documentIds: string[] }
  > {}

export const useCreateZipJob = (options?: UseCreateZipJobOptions) =>
  useMutation({
    ...options,
    mutationFn: async ({ organizationId, documentIds }) =>
      api.organization.archiveDocumentControllerCreateZipJob(organizationId, {
        documentIds,
      }),
  });
